import React from 'react';
import { Form, Icon, Input, Button, Checkbox, Modal, Select, message, Row, Col, Divider } from 'antd';
const { Search } = Input;
import ForgotPassword from './ForgotPassword'
import style from './Login.css';
import { browserHistory } from 'react-router';
const FormItem = Form.Item;
import $ from 'jquery';
import { sgiConfig, tool } from 'rt-sd-common';

const SearchBtn = (props) => {
    let { disabled, count, defaultName } = props
    return (
        <Button 
        style={{width:'120px',background: '#00b34f'}} 
        type='primary'>
            {disabled?count:defaultName}
        </Button>
    )
}

class NormalLoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openSso: ''
        };
        function getUrlParam(paraName) {
            let url = document.location.toString();
            let arrObj = url.split('?');
          
            if (arrObj.length > 1) {
              let arrPara = arrObj[1].split('&');
              let arr;
          
              for (let i = 0; i < arrPara.length; i++) {
                arr = arrPara[i].split('=');
          
                if (arr != null && arr[0] == paraName) {
                  return arr[1];
                }
              }
              return '';
            } else {
              return '';
            }
        }
        
        let hasToken = false
        this.openSso = sgiConfig.openSso

        let loginErrorFlag = false

        // 获取url参数openSso，覆盖sgiConfig中的默认值。允许外部用户登录，而不经过统一认证平台。
        let urlParamOpenSso = getUrlParam('openSso')
        console.log('sy -----  loginForm.js  constructor 1 urlParamOpenSso: ', urlParamOpenSso)
        if (urlParamOpenSso === 'false') {
            this.openSso = false
        }
        tool.setCookie('openSso', this.openSso);
        console.log('sy -----  loginForm.js  constructor 1. openSso: ', this.openSso)
        let cookieToken = tool.getCookie("token")
        let cookieMbl = tool.getCookie("mbl")
        // http://127.0.0.1:8490/?ticket=ST-21-bYsscPA1f51Hi2kD2yuzklgDKz0iMpz2bCN&service=http://127.0.0.1:8490/
        console.log('sy -----  loginForm.js  constructor 2 cookieToken: ', cookieToken)
        console.log('sy -----  loginForm.js  constructor 2 cookieMbl: ', cookieMbl)
        let ticket = getUrlParam('ticket');
        // let service = getUrlParam('service');
        const service = window.location.protocol + '//' + window.location.host + '/';
        console.log('sy -----  loginForm.js  constructor 3 ticket: ', ticket)
        console.log('sy -----  loginForm.js  constructor 3 service: ', service)

        if (tool.getCookie("token") && tool.getCookie("mbl")) {
            hasToken = true
            // browserHistory.push({
            //     pathname: '/main',
            //     state: {}
            // });
            console.log('sy -----  loginForm.js  constructor 4 tool.popSingleUI mail')
            tool.popSingleUI('/main');
        }
        if (this.openSso && ticket) {
            
            console.log('sy -----  loginForm.js  constructor 5 validateLogin')
            let mySuccessCallback = this.successCallback
            let onOkClick = this.onOkClick
            var success = function (res) {
                // debugger
                if (res && res.head && res.head.code == "0000") {
                    console.log('sy -----  loginForm.js  constructor 6 res: ', res)
                    tool.setCookie('token', res.body.token);
                    tool.setCookie('mbl', res.body.mbl);
                    hasToken = true
                    // tool.popSingleUI('/main');
                    console.log('sy -----  loginForm.js  constructor 6 call mySuccessCallback')
                    mySuccessCallback(res)
                } else {
                    console.log('login error', res);
                    loginErrorFlag = true;
                    tool.popMessage(res.head.msg || '账号登录异常,请联系运维人员', "error");
                    // tool.popMsgDialog(res.head.msg || '账号登录异常,请联系运维人员', "文本资源保存成功！");
                    tool.popMsgDialog("账号登录异常,请联系运维人员", res.head.msg || '账号登录异常,请联系运维人员', onOkClick, "error", null);
                    
                }
            };
            let requestUrl = sgiConfig.service_uam + "/index/cas/client/validateLogin?ticket=" + ticket + '&service=' + service
            console.log('sy -----  loginForm.js  constructor 6 validateLogin requestUrl: ', requestUrl)
            commonClient.simplecall(
                requestUrl,
                undefined,
                success,
                false,
                'get'
            );
        }
        this.state = {
            userPhone: null,
            suijiId: 1,
            userId: null,
            passwordIsPassed: false,
            passwordForget: false,
            hasTip: false,
            errMsg: '',
            validateStatus: '',

            countLoading: false,
            count:59
        }
        console.log('sy -----  loginForm.js  constructor 5 state: ', this.state)
        console.log('sy -----  loginForm.js  constructor 6 hasToken: ', hasToken)

        if(this.openSso && !hasToken && !loginErrorFlag) {
            let locationUrl = document.location.protocol +"//" + window.location.host + '/';
            console.log('ssoLogin  locationUrl: ', locationUrl)
            // debugger
            window.location.href = sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl);
        }


    }

    onOkClick() {
        let locationUrl = document.location.protocol +"//" + window.location.host + '/';
        console.log('账号登录异常 确认click: ', locationUrl, sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl))
        // debugger
        window.location.href = sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl);
    }

    countDown = () => {
        let { count } = this.state
        let timer = setInterval(()=>{
            this.setState({count: (count--)},()=>{
                if(count <= -1) {
                    clearInterval(timer)
                    this.setState({
                        count: 59,
                        countLoading: false
                    })
                }
            })
        },1000)
    }
    encrypt(val) {
        if(!sgiConfig.PublicKey) return val
        var encrypt = new JSEncrypt()
        encrypt.setPublicKey(sgiConfig.PublicKey)
        return encrypt.encrypt(val)
    }
    // 获取企业详细信息，并将社会信用代码存到cookie
    queryOrgInfos() {
        var success = function (res) {
            if (res && res.head && res.head.code == "0000") {
              console.log(res.body.socialCreditCode)
              tool.setCookie('socialCreditCode', res.body.socialCreditCode);
            }
        };
        commonClient.simplecall(
            sgiConfig.service_cust + "supMan/getSupInfo",
            { entId: tool.getCookie('orgId') },
            success
        );
    }
    successCallback(res) {
        let resList = res.body
        console.log('LoginForm successCallback. resList: ', resList)
        resList.enterpriseId = resList.orgId
        resList.enterpriseNam = resList.orgNam
        resList.passwordStatus = resList.passwordStatus
        resList.roleIdStr = resList.roleIds
       
        let allCookieKey = [];
        for (var key in resList) {
            tool.setCookie(key, resList[key], .5);
            allCookieKey.push(key);
        }

        tool.setCookie("allCookieKey", allCookieKey.join(","), .5);

        //连接websocket
        // wsLogin(loginInfo);
        tool.setCookie("LS", "1")//锁屏

        if (resList.passwordStatus == "1") {
            tool.popSingleUI("/FirstLoginChgPwd");
        } else {
            tool.popSingleUI('/main');
        }
        // this.queryOrgInfos()

        console.log('LoginForm successCallback. simplecall getSupInfo')
        var success = function (res) {
            if (res && res.head && res.head.code == "0000") {
              console.log(res.body.socialCreditCode)
              tool.setCookie('socialCreditCode', res.body.socialCreditCode);
            }
        };
        commonClient.simplecall(
            sgiConfig.service_cust + "supMan/getSupInfo",
            { entId: tool.getCookie('orgId') },
            success
        );

    }
    userLogin(data) {
        var req = data;
        data.loginPwd = this.encrypt(data.loginPwd)
        //登录追加前端PC端渠道号 registerChnl 01
        req.registerChnl = "01"

        console.log('LoginForm userLogin. req: ', req)

        var success = (res)=> {
            if (res && res.head.code === "0000") {
                if(res.body.token){
                    this.successCallback(res)
                }else{
                    this.setState({
                        passwordIsPassed: true,
                        userPhone: res.body.mbl,
                        userId: res.body.userId
                    })
                }
            } else {
                if (res && res.head.code === "0406") {
                    let req = {
                        riskType: "50", // 风险类型 50：用户风险
                        riskLevel: "01", // 风险等级 01：高 02：中 03：低
                        riskContent: `${data.userMobile}多次登录失败，账号已被锁定`, // 风险内容
                    }
                    commonClient.simplecall(sgiConfig.allUrl.RiskRegInfoAdd, req, () => { }, null, null, null, function (req) {
                        // req.head={};
                    })
                }
                if (res && res.head.code === "9991") {
                    tool.popSingleUI('/ChangePassword')
                }
                
                if (res.head.msg === '内部员工请通过IAM登录') {
                    // 跳转IAM
                    let locationUrl = document.location.protocol +"//" + window.location.host + '/'
                    console.log('ssoLogin  locationUrl: ', locationUrl)
                    // debugger
                    let url = sgiConfig.casBaseUrl + '/login?service=' + encodeURIComponent(locationUrl)
                    console.log('sy -----  loginForm.js 内部员工 自动跳转IAM: ', url)
                    window.location.href = url
                }
                message.error(res.head.msg);
            }
        };
        //    simplecall: function (path, data, callback, flag, reqType, aftercall, beforecall) {
        commonClient.simplecall(sgiConfig.allUrl.loginUri, req, success, null, null, null, function (req) {
        })
    }
    handleSubmit = (e) => {
        var me = this;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                tool.sgiLogger.info('Received values of dynamicForm: ', values);
                this.userLogin(values);
            }
        });
    }
    
    getUUID() {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }
    CaptchaPictureClick() {
        this.setState({
            suijiId: this.getUUID()
        })
    }

    togglepassed = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                tool.sgiLogger.info('Received values of dynamicForm: ', values);
                this.valdtsmsHandler(values);
            }
        });
    }

    valdtsmsHandler(data) {
        console.log(data)
        let success = (res) => {
            if (res && res.head.code === "0000") {
                this.successCallback(res)
            }else{
                // tool.sgiLogger.info(res.head.msg);
                tool.popMessage(res.head.msg, 'error');
            }
        }
        commonClient.simplecall(sgiConfig.allUrl.valdtsmsUri, {
            smsCode: data.smsCode,
            userId: this.state.userId
        }, success)
    }
    
    kaptchaCodeValidator = (rule, value, callback) => {
        if(!value) {
            this.state.validateStatus = 'error'
            return callback(new Error('请填写图片验证码!'))
        } 
        this.state.validateStatus = 'validating'
        let success = (res) => {
            if (res && res.head.code === "0000") {
                callback()
                this.state.validateStatus = 'success'
            }else{
                
                if(res.head.code === 0){
                    callback(new Error('网络错误！'))
                } else {
                    callback(new Error(res.head.msg))
                }
                this.state.validateStatus = 'error'
            }
        }
        commonClient.simplecall(sgiConfig.allUrl.vldtKaptchaUri, value, success)
    }
    
    sendNote = (params) => {
        if(this.state.countLoading) return
        let success = (res) => {
            console.log('开始倒计时')
                this.setState({
                    countLoading: true
                })
                if(!this.state.count == 0){
                    this.countDown()
                }
            if (res && res.head.code === "0000") {
                
            }else{
                
            }
            console.log(res)
        }
        commonClient.simplecall(sgiConfig.allUrl.sendNoteUri, {userId:this.state.userId}, success)
    }
    changePasswordHandler = () => {
        tool.popSingleUI('/main/ChangePassword',{},'修改密码')
    }
    forgetPasswordHandler = (passwordForget) => {
        this.setState({
            passwordForget
        })
    }
    resetPassword = (e) => {
        console.log('重置密码');
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) return
            this.resetPasswordHandler(values)
        });
    }
    resetPasswordHandler = (values) => {
        console.log(values);
        let req = {
            values: {
                ap: 'mn',
                ...values
            }
        }
        let success = (res) => {
            if (res && res.head.code === "0000") {
                this.forgetPasswordHandler(false)
                this.setState({
                    hasTip: true
                })
            }else{
                tool.popMessage(res.head.msg, "error");
            }
        }
        commonClient.simplecall(sgiConfig.service_uam + '/user/checkUserResetpwd', req, success)
        // commonClient.simplecall(sgiConfig.service_uam + '/user/resetpwd', values, success)

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        console.log('sy -----  loginForm.js  render 1')
        console.log('sy -----  loginForm.js  openSso', this.openSso)
        // if(this.openSso) return ;
        if(this.state.passwordForget){
            return(
                <Form onSubmit={this.resetPassword} className={style['login-dynamicForm']} className="loginform">
                    <FormItem>
                        {getFieldDecorator('userNam', {
                            rules: [{ required: true, message: '请输入用户名!' }],
                        })(
                            <Input size="large" 
                            // prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                            placeholder="请输入用户名" />
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('email', {
                            rules: [{ required: true, message: '请输入账号绑定的邮箱!' }],
                        })(
                            <Input size="large" 
                            // prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                            placeholder="请输入账号绑定的邮箱" />
                        )}
                    </FormItem>
                    {/* nicknam */}
                    <FormItem style={{marginBottom: '10px'}}>
                        <Row style={{fontSize:'12px'}}>
                            <Col span={12}>
                                
                            </Col>
                            <Col span={12} style={{textAlign:'right'}}>
                                <a onClick={() => {
                                    return this.forgetPasswordHandler(false)
                                }} style={{color:'#00b34f'}}>返回登录</a>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem style={{marginBottom: 0}}>
                        <Button size="large" type="primary" htmlType="submit" className={style['login-form-button']}>
                            确定
                        </Button>
                    </FormItem>
                    <div className={style.errMsg}> {this.state.errMsg}</div>
                </Form>
            )
        }
        return (
                !this.state.passwordIsPassed?
                <Form onSubmit={this.handleSubmit.bind(this)} className={style['login-dynamicForm']} className="loginform">
                    <FormItem style={{marginBottom: '18px'}}>
                        {getFieldDecorator('loginNam', {
                            rules: [{ required: true, message: '请输入用户名!' }],
                        })(
                            this.state.hasTip?
                            <span style={{position: 'relative'}}>
                                <span style={{fontSize: '12px',position: 'absolute',left: '0',top: '-45px'}}>您很快会收到一封关于接下来操作的邮件。</span>
                                <Input size="large" prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名" />
                            </span>
                            :<Input size="large" prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名" />
                                

                        )}
                    </FormItem>
                    <FormItem style={{marginBottom: '18px'}}>
                        {getFieldDecorator('loginPwd', {
                            rules: [{ required: true, message: '密码不能为空！' }],
                        })(
                            <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
                        )}
                    </FormItem>
                    <Row>
                        <Col span={12}>
                            <FormItem hasFeedback validateStatus={this.state.validateStatus}>
                                    {getFieldDecorator('kaptchaCode', {
                                        validateFirst: false,
                                        validateTrigger: 'onBlur',
                                        rules: [
                                            {
                                                validator: this.kaptchaCodeValidator,
                                            }
                                        ]
                                    })(
                                        <Input size="large" placeholder="验证码" />
                                    )}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem>
                                <div onClick={this.CaptchaPictureClick.bind(this)} className={style.changeOne} style={{lineHeight:'33px'}}>
                                    <img
                                        style={{ 
                                            height: '39px', 
                                            width: '100px',
                                            borderRadius:'5px'
                                        }}
                                        id='CaptchaPicture'
                                        src={sgiConfig.allUrl.kaptchaUri+ '?wd=' + this.state.suijiId}
                                        alt="" />
                                    <span style={{color:'#00b34f'}}> 换一张</span>
                                </div>             
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem style={{marginBottom: '10px'}}>
                        <Row style={{fontSize:'12px'}}>
                            <Col span={8}>
                                {getFieldDecorator('isRemember', {
                                    // rules: [{ required: true, message: '请输入用户名!' }],
                                })(
                                    <Checkbox style={{fontSize:'12px',color:'#00b34f'}}>记住企业信息</Checkbox>
                                )}
                                
                            </Col>
                            <Col span={16} style={{textAlign:'right'}}>
                                <a onClick={() => { tool.popSingleUI('/ChangePassword',{},'修改密码')
                                    // return this.changePasswordHandler()
                                }} style={{color:'#00b34f'}}>修改密码</a>
                                <Divider type="vertical" />
                                <a onClick={() => {
                                    return this.forgetPasswordHandler(true)
                                }} style={{color:'#00b34f'}}>重置密码</a>
                                <Divider type="vertical" />
                                <a onClick={() => { tool.popSingleUI('/Register');console.log('去注册') }} style={{color:'#00b34f'}}>马上注册</a>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem style={{marginBottom: 0}}>
                        <Button size="large" type="primary" htmlType="submit" style={{fontSize: '13px'}} className={style['login-form-button']}>
                            登录
                        </Button>
                    </FormItem>
                    <div className={style.errMsg}> {this.state.errMsg}</div>
                </Form>
                :<Form onSubmit={this.togglepassed} className={style['login-dynamicForm']} className="loginform">
                    {/* 手机号 设置禁用 */}
                    
                    <FormItem style={{margin: '38px 0'}}>
                    
                            <Input size="large" prefix={<Icon type="mobile" 
                            style={{ color: 'rgba(0,0,0,.25)' }} 
                            />} placeholder="用户名" disabled={true} defaultValue={this.state.userPhone} />
                    </FormItem>
                    {/* 短信验证码 */}
                    <FormItem style={{marginBottom: '38px'}}>
                        {getFieldDecorator('smsCode', {
                            rules: [{ required: true, message: '短信验证码' }],
                        })(
                            // <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="短信验证码" />

                            <Search
                            size="large"
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="短信验证码"
                            // enterButton={this.state.countLoading ? this.state.count + '秒' : '发送短信验证码'}
                            enterButton={SearchBtn({disabled: this.state.countLoading, count:this.state.count + ' 秒', defaultName:'发送验证码'})}
                            onSearch={this.sendNote}
                        />
                        )}
                    </FormItem>
                    <FormItem style={{marginBottom: 0}}>
                        <Button size="large" type="primary" htmlType="submit" className={style['login-form-button']}>
                            确定
                        </Button>
                    </FormItem>
                    <div className={style.errMsg}> {this.state.errMsg}</div>
                </Form>
        )
    }
}

const LoginForm = Form.create()(NormalLoginForm);

export default LoginForm;


// WEBPACK FOOTER //
// ./apps/pages/login/LoginForm.js